import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import { CardV2, CardHeader, CardTitle, CardContent } from '../../../components/CardV2/CardV2';

type PercentageCardProps = {
  title: string;
  percentage: number;
  numerator: number;
  denominator: number;
  description: string;
  isLoading?: boolean;
};

const PercentageCard = ({ 
  title, 
  percentage, 
  numerator,
  denominator,
  description,
  isLoading
}: PercentageCardProps) => {
  const { t } = useTranslation();
  return (
    <CardV2>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {isLoading ? (
            <div className="text-3xl font-bold text-foreground">...</div>
          ) : (
            <>
              <div className="text-3xl font-bold text-foreground">{percentage.toFixed(1)}%</div>
              <div className="text-xs text-muted-foreground">
                {t('stats.commission_contracts.contracts_count', { 
                  numerator: numerator.toLocaleString(), 
                  denominator: denominator.toLocaleString() 
                })}
              </div>
            </>
          )}
          <div className="flex items-start gap-2 text-sm text-muted-foreground">
            <Info className="h-4 w-4 mt-0.5 flex-shrink-0" />
            <p>{description}</p>
          </div>
        </div>
      </CardContent>
    </CardV2>
  );
};

export default PercentageCard;

